<form
  name="accountForm"
  novalidate
  *ngIf="hasEntitlement('VISITORS_ACCOUNTS_DETAILS')"
>
  <div class="card card-nc">
    <div class="card-heading">
      <div class="float-left">
        <span class="icon-NC_chip"></span
        ><span class="cardHeaderHeading"> ACCOUNT DETAILS </span>
      </div>
      <div
        class="float-right save-card zeroPadding"
        *ngIf="
          visitorCard.status + '' === 'ACTIVE' &&
          hasEntitlement('VISITORS_ACCOUNTS_UPDATE')
        "
      >
        <button
          [disabled]="currentCardStatus + '' === ''"
          type="submit"
          (click)="save()"
          class="btn btn-nc"
        >
          SAVE <i [ngClass]="{ processing: 'save_a_btn_spinner' }"></i>
        </button>
      </div>
    </div>
    <div class="card-body">
      <div class="row labelCommon cardRowBackground text-nowrap">
        <div class="col-md-2  col-centered accountBorder">
          <div class="col-md-12">Card ID</div>
          <div class="col-md-12 staticText1">
            {{ visitorCard.cardSeq }}
            <span
              *ngIf="isEMV(visitorCard.closedLoopPan) == true">
                <img id="EMV-card" src="assets/img/EMV.svg" alt=""/>
            </span>
          </div>
        </div>

        <div class="col-md-2  col-centered accountBorder">
          <div class="col-md-12">Issuance Date</div>
          <div class="col-md-12 staticText1">
            {{ visitorCard.issueDate | date: "MM/dd/yyyy" }}
          </div>
        </div>

        <div class="col-md-2  col-centered accountBorder">
          <div class="col-md-12">Expiry Date</div>
          <div class="col-md-12 staticText1">
            {{ visitorCard.expirationDate | date: "MM/dd/yyyy" }}
          </div>
        </div>

        <div class="col-md-2  col-centered accountBorder">
          <div class="col-md-12">Card Status Date</div>
          <div class="col-md-12 staticText1">
            {{ visitorCard.statusDate | date: "MM/dd/yyyy" }}
          </div>
        </div>

        <div class="col-md-4 ">
          <div class="col-md-12 zeroPadding">Status</div>
          <div class="row">
            <div
              class="form-group col-md-10"
              *ngIf="
                (visitorCard.status + '' === 'ACTIVE' ||
                  visitorCard.status + '' === 'PENDACTIVE') &&
                hasEntitlement('VISITORS_ACCOUNTS_UPDATE')
              "
            >
              <select
                name="cardStatus"
                id="cardStatus"
                [ngModel]="visitorCard.status"
                (ngModelChange)="currentCardStatus = $event"
                class="form-control input-sm"
                ><option
                  *ngFor="let cardStat of visitorCard.targetStats"
                  [value]="cardStat"
                  >{{ cardStat }}</option
                ></select
              >
            </div>
            <div
              class="form-group col-md-10 staticText1"
              *ngIf="visitorCard.status + '' !== 'ACTIVE'"
            >
              {{ visitorCard.status }}
            </div>
            <div class="col-md-2">
              <div
                [ngClass]="
                  visitorCard.status + '' === 'ACTIVE' ||
                    visitorCard.status + '' === 'PENDACTIVE' | circleGreenRed
                "
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div class="row chipRowBackground labelCommon text-nowrap">
        <div class="col-md-2  col-centered accountBorder">
          <div class="col-md-12">Chip Number</div>
          <div class="col-md-12 staticText1">{{ customerAccount.account }}</div>
        </div>
        <div class="col-md-2  col-centered accountBorder">
          <div class="col-md-12">Account Balance</div>
          <div class="col-md-12">
            <span class="staticText1"
              ><span class="dollerSymbolColor"><i class="fa fa-usd"></i></span
              >&nbsp;{{ customerAccount.currentBalance | currency: '':''}}</span
            >
          </div>
        </div>
        <div class="col-md-2  col-centered accountBorder">
          <div class="col-md-12">Chip Limit</div>
          <div class="col-md-12 staticText1">
            <span class="staticText1">{{ visitorCard.chipLimit | currency: '':''}}</span>
          </div>
        </div>
        <div class="col-md-2  col-centered accountBorder">
          <div class="col-md-12">Open Date</div>
          <div class="col-md-12 staticText1">
            {{ customerAccount.openDate | date: "MM/dd/yyyy" }}
          </div>
        </div>
        <div class="col-md-4 ">
          <div class="col-md-12 zeroPadding">Status</div>
          <div class="row">
            <div class="form-group col-md-10 ">
              {{ customerAccount.status }}
            </div>
            <div class="col-md-2">
              <div
                [ngClass]="
                  customerAccount.status + '' === 'OPEN' | circleGreenRed
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
